import React, { Component } from 'react';
import _ from 'underscore';

class DisclosureData extends Component {
    render() {
        let asOfDate = this.props.dataManager.asOfDate;
        let fundsList = Object.values(this.props.dataManager.funds);
        
        if (this.props.limitToSelected){
            fundsList = _.sortBy(_.filter(fundsList, item => {
                return this.props.selectedFunds[item.id];
            }), 'display');
        }
        
        return (
            <div className="disclosures">
                <table className={"table table-sm " + (this.props.forReport ? '':'table-striped table-bordered')}>
                    <thead className="thead-light">
                        <tr>
                            <th>&nbsp;</th>
                            <th>Identifier</th>
                            <th>Prospectus Net Expense Ratio</th>
                            <th><span>Std. Dev - as of {asOfDate}*</span></th>
                            <th><span>1-Year return as of {asOfDate}</span></th>
                            <th><span>5-Year return as of {asOfDate}</span></th>
                            <th><span>10-Year/Since inception return as of {asOfDate}</span></th>
                            <th>Inception Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fundsList.map((fund) => {
                            let discData = this.props.dataManager.disclosures[fund.ticker];
                            if (!discData)return null;
                            let addSuperScript = (fund.ticker === '08182G883' || fund.ticker === '08182G719');
                            return(
                                <tr key={'disc' + fund.ticker}>
                                    <td className="wide">{discData[0]}</td>
                                    <td>{discData[1]}{addSuperScript?<sup>A</sup>:null}</td>
                                    <td>{discData[3]}</td>
                                    <td>{discData[6]}</td>
                                    <td>{discData[8]}</td>
                                    <td>{discData[9]}</td>
                                    <td>{discData[10]}</td>
                                    <td>{discData[11]}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <p className="footnote">
                    *3-year annualized standard deviation as of {asOfDate}.<br/>
                    Source: Morningstar
                </p>
            </div>            
        );
    }
}

export default DisclosureData;
